// extracted by mini-css-extract-plugin
module.exports = {"component":"ViewpointTrigger_component__9HcGn","anchor":"ViewpointTrigger_anchor__gvgd3"};